import { ESortDirection } from 'ui/EasTable/types';
import { TOrderBy } from 'redux/types';

/** Partner reports are sorted by id, the newest first. */
export const PARTNER_REPORTS_ORDER_BY: TOrderBy[] = [
	{ fieldName: 'id', direction: ESortDirection.DESC },
];

/** Reports are spreadsheets, used when the response does not name the file. */
export const PARTNER_REPORT_FILE_EXTENSION = 'xlsx';

/** One partner gets a fee report per month, so a single page is enough for the partner dialog. */
export const PARTNER_REPORTS_DIALOG_PAGE_SIZE = 1000;
